import * as React from 'react';
import { translate } from 'react-i18next';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { IUserPaymentMethod } from 'models/user/userpayments';
import { PortalPageSection } from 'components/PortalStructure';
import renderIcon from 'helpers/renderIcon';
import { BasicButton } from 'components/Common/Button';
//TODO: uncomment
// import { Field } from 'redux-form';
// import { PortalSwitchField } from 'components/FormControls';

require('./style.css');

interface IProps extends IItemCardProps {
	item: IUserPaymentMethod;
	setDefaultUserPaymentMethod?: (paymentMethodId: string) => void;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserPaymentMethodItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.handleSetDefaultUserPaymentMethodClick = this.handleSetDefaultUserPaymentMethodClick.bind(this);
	}

	public editItem() {
		if (this.props.editItem) {
			this.props.editItem(this.props.item.id);
		}
	}

	public deleteItem(e: any) {
		e.stopPropagation();
		if (this.props.deleteItem) {
			this.props.deleteItem(null, this.props.item.id);
		}
	}

	private handleSetDefaultUserPaymentMethodClick(e: React.SyntheticEvent, paymentMethodId: string) {
		e.preventDefault();
		this.props.setDefaultUserPaymentMethod(paymentMethodId);
	}

	public render() {
		const { item, t } = this.props;

		return (
			<div key={item.id} className="userPaymentMethodItemCard">
				{/* <PortalPageSection  title={t('User_Shipping_ShippingAddresses_Label_Address')} description={`${name}${item.addressLine1}, ${item.zipCode} ${item.city}, ${country}${fullPhoneNumber}`} /> */}

				<PortalPageSection readOnly={true}>
					<dl className="list">
						<dt className="name">{item.name}</dt>
						<dd className="delete">
							<BasicButton onClick={this.deleteItem}>{renderIcon('delete_2')}</BasicButton>
						</dd>
						<dt>{t('UserPaymentMethod_CardNumber')}</dt>
						<dd>•••• •••• •••• {item.cardNumber}</dd>
						<dt>{t('UserPaymentMethod_ExpirationDate')}</dt>
						<dd>{item.expirationDate}</dd>
					</dl>
					<hr />
					<dl>
						<dt>{t('UserPaymentMethod_SetAsDefaultText')}</dt>
						<dd>
							{/* TODO: uncomment */}
							{/* <Field
                name="setDefaultPaymentMethodField"
                component={PortalSwitchField}
                type="checkbox"
              /> */}
						</dd>
					</dl>
				</PortalPageSection>
			</div>
		);
	}
}

export { UserPaymentMethodItemCard };
